module.exports = __webpack_public_path__ + "img/icon@2x.49083054.png";